import ConditionalToolTip from "components/design/conditionalToolTip";
import ToolTip from "components/design/toolTip";
import { ReactNode } from "react";

type PanelFieldProps = {
  label: string;
  tooltip?: ReactNode;
  children: ReactNode;
};

export const PanelField = ({ label, tooltip, children }: PanelFieldProps) => {
  return (
    <ConditionalToolTip condition={tooltip && tooltip}>
      <div className="t-flex t-min-w-0 t-flex-col t-gap-0.5">
        <span className="t-text-body-sm t-text-neutral-50">{label}</span>
        <div className="t-text-body t-text-text-100">{children}</div>
      </div>
    </ConditionalToolTip>
  );
};
